/*************************************************************************
 *
 * KLEARNOW CONFIDENTIAL
 * __________________
 *
 *  Copyright (c) 2018 - 2021 KlearExpress Corporation.
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of KlearExpress Corporation and its suppliers,
 * if any.  The intellectual and technical concepts contained
 * herein are proprietary to KlearExpress Corporation
 * and its suppliers and may be covered by U.S. and Foreign Patents,
 * patents in process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from KlearExpress Corporation.
 */

// Opportinity
export const OPPORTUNITY_BID_CLICKED = "OPPORTUNITY_BID_CLICKED";
export const OPPORTUNITY_ARROW_CLICKED = "OPPORTUNITY_ARROW_CLICKED";

export const OPPORTUNITY_UPDATE_CLICKED = "OPPORTUNITY_UPDATE_CLICKED";


export const ADDITONAL_CHARGE_DONE_CLICKED = "ADDITONAL_CHARGE_DONE_CLICKED";
export const ADDITONAL_CHARGE_CANCEL_CLICKED = "ADDITONAL_CHARGE_CANCEL_CLICKED";


export const OPPORTUNITY_BID_MODAL_BID_CLICKED = "OPPORTUNITY_BID_MODAL_BID_CLICKED";
export const OPPORTUNITY_BID_MODAL_PORT_ADDITIONAL_CHARGE_CLICKED = "OPPORTUNITY_BID_MODAL_PORT_ADDITIONAL_CHARGE_CLICKED";
export const OPPORTUNITY_BID_MODAL_SUBMIT_CLICKED = "OPPORTUNITY_BID_MODAL_SUBMIT_CLICKED";
export const OPPORTUNITY_BID_MODAL_CANCEL_CLICKED = "OPPORTUNITY_BID_MODAL_CANCEL_CLICKED";


export const LANE_BID_DONE_CLICKED = "LANE_BID_DONE_CLICKED";
export const LANE_BID_CANCEL_CLICKED = "LANE_BID_CANCEL_CLICKED";
export const LANE_BID_ADDITIONAL_CHARGE_CLICKED = "LANE_BID_ADDITIONAL_CHARGE_CLICKED";


//Standard additional charges
export const PARTNER_STANDARD_ADDITIONAL_CHARGES = "PARTNER_STANDARD_ADDITIONAL_CHARGES";

//API

export const API_GET_OPPORTINITY_LIST = "API_GET_OPPORTINITY_LIST";
export const API_GET_OPPORTINITY_DETAILS = "API_GET_OPPORTINITY_DETAILS";

//Internal bid data storage - when user enters bid info in any form for a given opportunity
export const SET_OPPORTUNITY_BID_DATA = "SET_OPPORTUNITY_BID_DATA";

export const PARTNER_SET_ID = "PARTNER_SET_ID";
